import { Grid2, Skeleton } from '@mui/material'

import { Maybe } from '@/clients/utoniq-core/schema'
import { SideMenuProps } from '@/components/layouts'
import { ScrollFetcher } from '@/components/organisms/functionals'

import { EmptyGalleryList } from './EmptyGalleryList'
import { GalleryListItem } from './GalleryListItem'
import { useGalleryList } from './useGalleryList'

export type GalleryProps = {
  categoryId: string
  user?: Maybe<SideMenuProps['user']>
  responsive?: boolean
}

export const GalleryList = ({
  categoryId,
  user,
  responsive = false,
}: GalleryProps) => {
  const { state, actions } = useGalleryList({ categoryId })

  return (
    <>
      <ScrollFetcher
        component={Grid2}
        componentProps={{
          container: true,
          spacing: 0,
          padding: '0 3px',
        }}
        itemComponent={Grid2}
        itemComponentProps={{
          size: responsive ? { xs: 4, md: 3 } : { xs: 4 },
        }}
        nodes={state.posts.map(post => {
          return <GalleryListItem key={post.id} post={post} user={user} />
        })}
        onFetchMore={actions.onFetchMore}
        loading={state.refetching || state.loading}
        hasNextPage={state.hasNextPage}
        emptyMessage={<EmptyGalleryList />}
        loadingComponent={
          <Grid2 container spacing={1} sx={{ width: '100%' }}>
            {Array.from(Array(30).keys()).map(key => (
              <Grid2 size={responsive ? { xs: 4, md: 3 } : { xs: 4 }} key={key}>
                <Skeleton
                  variant="rounded"
                  sx={{
                    width: '100%',
                    paddingTop: '100%',
                  }}
                />
              </Grid2>
            ))}
          </Grid2>
        }
      />
    </>
  )
}
